/*!

=========================================================
* Vue Argon Dashboard - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './registerServiceWorker'
import ArgonDashboard from './plugins/argon-dashboard'

import 'zingchart/es6';
import zingchartVue from 'zingchart-vue';


import loading from 'vuejs-loading-screen'

Vue.use(loading, {
    // bg: '#41b883ad',
     bg: '#4295e5ad',
    // icon: 'refresh',
    size: 5,
    icon_color: 'white',
})


Vue.component('zingchart', zingchartVue)

Vue.config.productionTip = false

window.axios = require('axios');

Vue.use(ArgonDashboard)
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
